export default __webpack_public_path__ + "static/media/Breeches of the Faceless Chaos.febbd915.jpg";